/** 요청마다 새로 만든다. 서버는 이 값을 traceId 로 이어 쓴다(X5). */
export function createRequestId(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  // 보안 컨텍스트가 아닌 곳(http 개발 주소)에서는 randomUUID 가 없다.
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
